import React from 'react'
import Card from '../nura/card/card'
import Modal from '../modal/modal'
import BaseForm from "../base-form/base-form"
import { useMediaQuery } from '@mui/material'

export default ({ show, onClose, src, title }) => {
    const isMobile = useMediaQuery('(max-width: 900px)')

    return (
        <Modal show={show} onClose={onClose}>
            <Card variant="modal" style={{ width: 'fit-content', maxWidth: isMobile? 350 :800 }}>
                <BaseForm onBack={onClose} title={title}>
                    <img style={{ marginTop: 20 }} src={src}/>
                </BaseForm>
            </Card>
        </Modal>
    )
}